import { Line } from '@ant-design/plots';
import { CaretUpOutlined, CaretDownOutlined, DoubleLeftOutlined } from "@ant-design/icons";
import { Link, useParams } from 'react-router-dom';
import { Button, Card, Col } from 'antd';
import { authRequest } from '../common/request/authRequest';
import { useEffect, useState } from 'react';
import moment from 'moment';

export const MarketRatesByMetal = () => {

	const { metal } = useParams();

	const [last12Months, setLast12Months] = useState(null)
	const [data, setData] = useState(null)
	const [isLoading, setIsLoading] = useState(true)

	useEffect(() => {
		authRequest(`${process.env.REACT_APP_API}/market/${metal}/last12months`, {}).then((data) => {
			setLast12Months(data.last12Months)
			setData(data)
			setIsLoading(false)
		})
	}, [])

	const chartMonthlyConfig = {
		min: 'auto',
		autoFit: true,
		xField: 'x',
		yField: 'value',
		color: 'SlateGray',
		yAxis: {
			min: 50000
		},
		xAxis: {
			label: {
				autoHide: true,
				autoRotate: true,

			},
			tickCount: 6,
		},
		xAxis: {
			label: {
				formatter: (text) => {
					const formattedDate = moment(text, 'DD/MM/YY').format('MMM YY');
					return formattedDate;
				},
				//autoHide: true,
				autoRotate: true,
			},
		},
		/*slider: {
			start: 0,
			end: 1,
			trendCfg: {
				isArea: true,
			},
		},*/
		smooth: false,
	};


	
	
	return (
		<div className="general-container" >
	
			<div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
				<div>
					<h2 className='title-chart' style={{color:'var(--header-grey)'}}>Cotización</h2>
					<small className='title-chart' style={{color:'var(--header-grey)'}}>Últimos 12 meses</small>
				</div>
				
				<Button size='small' style={{ display: 'flex', justifyContent:'center', alignItems:'center', color: 'var(--dark-accent)', borderColor: 'var(--dark-accent)', fontSize: '15px', backgroundColor:'white' }}><Link to={'/market'}><b> Atrás</b> </Link> </Button>
			</div>

			<div style={{ marginTop: '10px' }}>

				{/* <h3 className='title-chart'>Cotizaciones en euros por Onza</h3> */}

				{data &&
					<Card style={{ margin: '10px 0px', border:'.5px solid var(--header-grey)', background:'ivory' }} size='small'>
						<div style={{ display: 'flex', alignItems: 'center', justifyContent:'space-between', gap: '5px' }}>
							<div style={{textAlign:'center'}}>
								<p style={{color:'grey'}}>Ayer</p>
								<b style={{ fontSize: '13px' }}>{data?.previousQuote?.value}€/oz</b>
							</div>
							<div style={{ backgroundColor: 'transparent', width: '80px', height: '80px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', borderRadius: '15px', margin: '10px 0px', paddingTop: '5px' }}>
								<div style={{ border: '3px solid var(--dark-accent)', borderRadius: '5px', height: '35px', width: '35px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
									<span style={{ fontWeight: '700', color:'var(--dark-accent)' }}>{data?.metal}</span>
								</div>
								<div style={{ margin: '5px 0px', height: '3px', width: '15px', backgroundColor: 'var(--dark-accent)' }}></div>
								<b style={{ color:'var(--dark-accent)' }}>{data?.metalName}</b>
							</div>
							<div style={{textAlign:'center'}}>
								<p style={{color:'grey'}}>Hoy</p>
								<b style={{ fontSize: '13px' }}>{data?.currentQuote?.value}€/oz</b>
							</div>

							{/*<div style={{ color: data?.increment >= 0 ? 'green' : 'red', fontSize: '12px' }}>
								{data?.increment >= 0 ? <CaretUpOutlined /> : <CaretDownOutlined />}
				{(data?.increment).toFixed(2)}%</div>*/}
						</div>
					</Card>}

				{!isLoading && last12Months && <div style={{ marginTop: '25px' }}>
					<Line data={last12Months} 
					{...chartMonthlyConfig} 
					isLoading={isLoading} />
				</div>}

			</div>
		</div>
	)
}